module.exports = __webpack_public_path__ + "media/vid_phone_case2.e22db3e4.mp4";